import { TableCell } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { formatDateMoment } from 'utils'

interface Props {
  children: string | undefined
  daysDiff: number
}

export default function PastDueCell({ children, daysDiff }: Props) {
  return (
    <TableCell
      sx={theme => ({
        color: children && moment().diff(moment(formatDateMoment(children)), 'days') >= daysDiff ? theme.palette.error.main : 'inherit',
        fontWeight: children && moment().diff(moment(formatDateMoment(children)), 'days') >= daysDiff ? 'bold' : 'inherit'
      })}
    >
      {formatDateMoment(children)}
    </TableCell>
  )
}
